<template>
  <v-app>
    <v-locale-provider :locale="language">
      <AppBar v-if="!isEmbed" />
      <!-- <SelectLanguage v-if="isEmbed && !lang" :isEmbed="true" /> -->
      <v-main>
        <router-view />
      </v-main>
      <Footer v-if="!isEmbed" />
    </v-locale-provider>
  </v-app>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Footer from "./components/Footer.vue";
import AppBar from "./components/AppBar.vue";
// import SelectLanguage from "./components/SelectLanguage.vue";
export default {
  components: { 
    Footer, 
    AppBar, 
    // SelectLanguage 
  },
  name: "App",
  computed: {
    ...mapGetters({
      language: "appSetting/getLanguage",
    }),
    isEmbed() {
      return this.$route.query.embed == 'true' ? true : false;
    },
    lang() {
      let lang = null
      if (this.$route.query.lang == 'th') {
        lang = 'th'
      } else if (this.$route.query.lang == 'en') {
        lang = 'en'
      } else if (this.$route.query.lang == 'lo') {
        lang = 'lo'
      }
      return lang;
    },
  },
  watch: {
    lang: {
      handler(newLang, oldLang) {
        if (newLang && newLang != oldLang) {
          this.setLanguage(newLang)
          this.$i18n.locale = newLang
          this.$moment.locale(this.$helper.langToFullLang(newLang) || "en-US")
        }
      },
    }
  },
  methods: {
    ...mapMutations({
      setLanguage: "appSetting/setLanguage"
    })
  }
};
</script>
